import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LandingComponent } from './landing.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PrintOrderComponent } from './components/print-order/print-order.component';
import { ThesisOrderComponent } from './components/thesis-order/thesis-order.component';
import { SubmitBtnComponent } from './components/print-order/submit-btn/submit-btn.component';
import { ThesisEditOrderComponent } from './components/thesis-edit-order/thesis-edit-order.component';
import { UserNameDropdownComponent } from './components/landing-toolbar/user-name-dropdown/user-name-dropdown.component';
import { ShoppingCartDropdownComponent } from './components/landing-toolbar/shopping-cart-dropdown/shopping-cart-dropdown.component';
import { TarefeComponent } from './components/print-order/tarefe/tarefe.component';
import { LandingToolbarComponent } from './components/landing-toolbar/landing-toolbar.component';
import { PrintMixedRangeSelectComponent } from './components/print-mixed-range-select/print-mixed-range-select.component';
import { LandingAuthBoxService } from './services/landing-auth-box.service';
import {
  ColorPickerComponent,
  FileUploadComponent,
  FileUploadPopupComponent,
  LogoAnimationComponent,
  NotificationAreaComponent,
  NotificationIndicatorComponent,
  OrderShareComponent,
  PrintBlockContainerComponent,
  PrintBlockSingleInputComponent,
  PrintBtnToggleComponent,
  PrivatePublicToggleComponent,
  RangeSelectMainComponent,
  TransportationMethodComponent,
  UserIndicatorComponent,
} from '../components';

import {
  AuthFormComponent,
  GetCodeComponent,
  GetPhoneComponent,
  LoginComponent,
  RegisterComponent,
} from 'src/app/core/components';

import { FlexLayoutModule } from '@angular/flex-layout';
import { ConfigService } from 'src/app/core';
import { ActivationComponent } from 'src/app/core/components/activation/activation.component';
import { TalcColorSelectorComponent } from '../../shared/components/order/talc-color-selector/talc-color-selector.component';
import { LandingUserMenuComponent } from './components/landing-user-menu/landing-user-menu.component';
import Lottie from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { landingRoutes } from './landing.routes';
import { RangeInputComponent } from './components/range-select/range-select.component';
import { DynamicContentComponent } from './components/dynamic-content/dynamic-content.component';
import { LandingVideoComponent } from './components/landing-video/landing-video.component';
import { QuestionComponent } from './components/question/question.component';
import { RegisterModalComponent } from './components/register-modal/register-modal.component';

@NgModule({
  declarations: [
    LandingComponent,
    LandingToolbarComponent,
    PrintOrderComponent,
    DynamicContentComponent,
    LandingVideoComponent,
    QuestionComponent,

    SubmitBtnComponent,
    UserNameDropdownComponent,
    ThesisOrderComponent,
    ThesisEditOrderComponent,
    ShoppingCartDropdownComponent,
    TarefeComponent,
    PrintMixedRangeSelectComponent,
    PrintBlockContainerComponent,
    ColorPickerComponent,
    FileUploadComponent,
    FileUploadPopupComponent,
    UserIndicatorComponent,
    PrintBlockSingleInputComponent,
    NotificationAreaComponent,
    LogoAnimationComponent,
    NotificationIndicatorComponent,
    GetPhoneComponent,
    GetCodeComponent,
    ThesisOrderComponent,
    LandingUserMenuComponent,
    OrderShareComponent,
    RegisterComponent,
    LoginComponent,
    AuthFormComponent,
    ActivationComponent,
    SubmitBtnComponent,
    RangeSelectMainComponent,
    ShoppingCartDropdownComponent,
    GetPhoneComponent,
    OrderShareComponent,
    PrintBtnToggleComponent,
    TalcColorSelectorComponent,
    LogoAnimationComponent,
    PrivatePublicToggleComponent,
    TransportationMethodComponent,
    RangeInputComponent,
    RegisterModalComponent,
  ],

  imports: [
    CommonModule,
    SharedModule,
    FlexLayoutModule,

    LottieModule.forRoot({
      player: () => import('lottie-web'),
    }),

    RouterModule.forChild(landingRoutes),
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    LandingAuthBoxService,
    ConfigService,
    {
      provide: 'LOTTIE_WEB',
      useValue: Lottie,
    },
  ],
  exports: [
    RouterModule,
    PrintOrderComponent,
    DynamicContentComponent,
    LandingToolbarComponent,
    LandingUserMenuComponent,
    ShoppingCartDropdownComponent,
    NotificationAreaComponent,
  ],
})
export class LandingModule {}
